import { mergeProps, splitProps } from 'solid-js';
import { JSX } from 'solid-js/jsx-runtime';

export const FolderIcon = (props: JSX.SvgSVGAttributes<SVGSVGElement>) => {
  const merged = mergeProps(
    {
      width: 16,
      height: 16,
    },
    props,
  );

  const [local, rest] = splitProps(merged, ['width', 'height']);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      {...local}
      {...rest}
    >
      <rect width="256" height="256" fill="none" />
      <path
        d="M224,88V200.89a7.11,7.11,0,0,1-7.11,7.11H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33a8,8,0,0,1,4.8,1.6L128,80h88A8,8,0,0,1,224,88Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
    </svg>
  );
};
